import {
  SET_BACKEND,
  SET_RGB_STREAM_SETTINGS,
  SET_THERMAL_STREAM_SETTINGS,
  SET_RGB_FACE_DETECTION_SETTINGS,
  SET_THERMAL_FACE_DETECTION_SETTINGS,
  START_THERMAL_PROCESS,
  CLEAR_THERMAL_SOLUTION_BOX,
  SET_MASK_DETECTION_SETTINGS,
} from './actions';

const initialState = {
  backend: 'wasm',
  rgbStreamSettings: {
    videoWidth: 640,
    videoHeight: 480,
    videoDeviceIndex: 0,
    videoDeviceTrack: 0,
    boundingBoxShow: true,
  },
  rgbFaceDetectionSettings: {
    faceDetectionImageMinWidth: 128,
    faceDetectionImageMinHeight: 128,
    maxFaces: 10,
    iouThreshold: 0.1,
    scoreThreshold: 0.92,
    solutionBoxSize: 10,
  },
  thermalStreamSettings: {
    videoWidth: 320,
    videoHeight: 256,
    videoDeviceIndex: 0,
    videoDeviceTrack: 0,
    mode: 'stream',
    thermalDataReadFormat: 'RED',
    boundingBoxShow: true,
    solutionBoxSize: 10,
  },
  thermalFaceDetectionSettings: {
    faceDetectionImageMinWidth: 128,
    faceDetectionImageMinHeight: 128,
    maxFaces: 10,
    iouThreshold: 0.1,
    scoreThreshold: 0.75,
    solutionBoxSize: 10,
  },
  maskDetectionsSettings: {
    mobileNetVersion: '264',
    mobileNetWeight: '0.35',
    mobileNetType: 'float16',
    thumbnailSizeForMask: 64,
  },
  isClearThermalSolutionBox: false,
  isStartThermalProcess: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_BACKEND:
      return {
        ...state,
        backend: action.backend,
      };
    case START_THERMAL_PROCESS:
      return {
        ...state,
        isStartThermalProcess: action.value,
      };
    case CLEAR_THERMAL_SOLUTION_BOX:
      return {
        ...state,
        isClearThermalSolutionBox: action.value,
      };
    case SET_THERMAL_STREAM_SETTINGS:
      return {
        ...state,
        thermalStreamSettings: {
          ...state.thermalStreamSettings,
          [action.field]: action.data,
        },
      };
    case SET_MASK_DETECTION_SETTINGS:
      return {
        ...state,
        maskDetectionsSettings: {
          ...state.maskDetectionsSettings,
          [action.field]: action.data,
        },
      };
    case SET_RGB_STREAM_SETTINGS:
      return {
        ...state,
        rgbStreamSettings: {
          ...state.rgbStreamSettings,
          [action.field]: action.data,
        },
      };
    case SET_RGB_FACE_DETECTION_SETTINGS:
      return {
        ...state,
        rgbFaceDetectionSettings: {
          ...state.rgbFaceDetectionSettings,
          [action.field]: action.data,
        },
      };
    case SET_THERMAL_FACE_DETECTION_SETTINGS:
      return {
        ...state,
        thermalFaceDetectionSettings: {
          ...state.thermalFaceDetectionSettings,
          [action.field]: action.data,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default reducer;
